import React from "react";
import {
  Card,
  Grid,
  CardHeader,
  CardMedia,
  CardActions,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

const MemeCard = props => {
  let history = useHistory();

  function handleClick() {
    history.push("/create", { meme: props.meme });
  }

  const classes = useStyles();
  return (
    <>
      <Grid item xs={3}>
        <Card className={classes.root}>
          <CardHeader title={props.meme.name} />
          <CardMedia className={classes.media} image={props.meme.url} />
        </Card>
        <CardActions>
          <Button variant="outlined" onClick={handleClick}>
            Create Meme
          </Button>
        </CardActions>
      </Grid>
    </>
  );
};

export default MemeCard;

const useStyles = makeStyles({
  root: {
    margin: 10,
    height: 400
  },
  media: {
    height: 350
  }
});
